export default "__VITE_ASSET__CTJmmOPR__"